import { CustomDataSearchModel } from '../../custom-data/models/custom-data-search-field.model';
import { ExportRequiredDataModel } from '../../content-distribution/_index';
import { UiModuleGroupsConfig } from './ui-module.model';

export enum UiModuleOverviewDisplayStyle {
  List = 1,
}

export class UiModuleOverviewConfiguration {
  static default(): UiModuleOverviewConfiguration {
    return {
      id: 0,
      summaryConfig: null,
      groupsConfig: null,
      pageSize: 20,
      sortFieldCode: null,
      sortOrder: null,
      taskProgressConfig: null,
      displayColumnsCodes: null,
      displayFieldsConfiguration: [],
      headerConfig: null,
      defaultFilter: null,
      requiredData: null,
    };
  }
}

export interface UiModuleOverviewConfiguration {
  id: number;
  summaryConfig: UiModuleOverviewSummaryConfig;
  groupsConfig: UiModuleGroupsConfig;
  pageSize: number;
  sortFieldCode: string;
  sortOrder: boolean;
  taskProgressConfig: UiModuleOverviewTaskProgressModel;
  displayColumnsCodes: string;
  displayFieldsConfiguration?: DisplayFieldConfiguration[];
  headerConfig: UiModuleOverviewHeaderConfigModel;
  defaultFilter: UiModuleOverviewDefaultFilterConfig;
  requiredData?: ExportRequiredDataModel[];
}

export enum TaskProgressDisplayType {
  AllTasks,
  ColumnPerTaskGroup,
}

export enum TaskProgressDisplayFormat {
  Percentage,
  Absolute,
}

export enum TaskProgressIndicatorType {
  ProgressBar,
  PlainText,
}

export interface UiModuleOverviewTaskProgressModel {
  displayType: TaskProgressDisplayType;
  displayFormat: TaskProgressDisplayFormat;
  colorMapping: TaskProgressColorMap[];
  indicatorType: TaskProgressIndicatorType;
}

export interface TaskProgressColorMap {
  boundary: number | null;
  color: string;
}

export interface UiModuleOverviewSummaryConfig {
  actions?: UiModuleOverviewSummaryActionModel[];
  allowEdit: boolean;
  fields: string[];
  primaryAction?: string;
}

export interface UiModuleOverviewHeaderConfigModel {
  displayStyle: UiModuleOverviewDisplayStyle;
  invoiceFlows: string[];
  selectedFlow?: string;
  debtorSelector?: string;
  showSimpleSearch: boolean;
  showAdvancedSearch: boolean;
  showExportButton: boolean;
  showAddButton: boolean;
  showBatchUpdateButton: boolean;
}

export interface UiModuleOverviewSummaryActionModel {
  displayName: string;
  icon: string;
  fieldCode: string;
}

export interface DisplayFieldConfiguration {
  field: string;
  subDisplayFields?: string;
  sortField?: number;
  columnName?: string;

  // ui only
  name?: string;
}

export interface UiModuleOverviewDefaultFilterConfig
  extends CustomDataSearchModel {
  includeInSearch?: OverviewPageSearchType | null;
}

export enum OverviewPageSearchType {
  SimpleSearch = 1,
  AdvancedSearch = 2,
}
